export const MESSAGE_DURATION_SECONDS = 2000
export const ANIMATION_FADEOUT_DELAY_SECONDS = MESSAGE_DURATION_SECONDS - 200
export const MESSAGE = {
  REVIEW_AFTER_EDITS: 'Click review after making your edits',
  HIGHLIGHT_SYNONYMS: 'Highlight words for synonym',
  HIGHLIGHT_REWRITE: 'Highlight sentence to rewrite',
  WORD_LIMIT_EXCEEDS: 'Reached the word limit',
}

export const STORAGE_KEY_FOR_REWRITE_SYNONYMS_INFO_TOOLTIP = 'rewrite-synonyms-viewed'

export enum REWRITE_SYNONYMS_VIEWED_STATE {
  REWRITE = 'REWRITE',
  SYNONYMS = 'SYNONYMS',
  NONE = 'NONE',
}
